import {API_ERROR, API_SUCCESS, apiRequest} from "../../../actions/core/api/api.actions";
import {setError, setLoader} from "../../../actions/app/ui/ui.actions";
import {setNotification} from "../../../actions/core/notifications/notifications.actions";
import {setDashboard, FETCH_DASHBOARD} from "../../../actions/app/dashboard/dashboard.actions";

export const dashboardMiddleware = ({dispatch}) => next => action => {
    next(action)

    switch (action.type){
        case FETCH_DASHBOARD:
            next([
                apiRequest({body: null, method: 'GET', url: action.payload.data, entity: FETCH_DASHBOARD}),
                setLoader({state: true, entity: FETCH_DASHBOARD})
            ])
            break

        case `${FETCH_DASHBOARD} ${API_SUCCESS}`:
            next([
                setDashboard({data: action.payload.data}),
                setError({state: false, entity: FETCH_DASHBOARD}),
                setLoader({state: false, entity: FETCH_DASHBOARD})
            ])
            break

        case `${FETCH_DASHBOARD} ${API_ERROR}`:
            next([
                setNotification({
                    entity: FETCH_DASHBOARD,
                    html: `<div><p>${action.payload.data.response?.data.reason || "Erreur lors de la récupération du dashboard"}</p></div>`,
                    icon: 'error',
                    title: 'Attention !',
                    confirmButtonText: 'J\'ai compris'
                }),
                setError({state: true, entity: FETCH_DASHBOARD}),
                setLoader({state: false, entity: FETCH_DASHBOARD})
            ])
            break

        default:
            break
    }
    return null
}
